import { PositiveDirection } from '@legacy-modules/metrics2/models/entities/PositiveDirection';

import { ChartType } from '@legacy-modules/metrics2/models/enumerations/ChartType';
import ValueExpression from '@legacy-modules/valueexpressions/models/valueexpressions/ValueExpression';

export default new ValueExpression({
  identifier: 'tour_loaded.deliveryitems.services.identservice.count',
  label: 'Sendungen mit Identservice',
  chart: ChartType.bar,
  positiveDirection: PositiveDirection.custom,
  category: 'delivery-items',
  description:
    '<p>Anzahl aller auf der geladenen Tour geplanten Empfänger mit einer Identsendung gezählt ' +
    'nach dem ersten abgeschlossenen Zustellvorgang</p>\n',
});
